<template>
  <div class="borrowers">
    <div class="title">{{ $t('meetOurBorrowers') }}</div>
    <div class="items">
      <div>
        <div class="talk-bg">
          {{ $t('borrower1') }}
        </div>
        <div class="child-v-center">
          <img src="@/assets/image/home/borrowers/comments_user01@2x.png">
          <div class="info">
            <div class="name">Lisa Rahayu</div>
          </div>
        </div>
      </div>
      <div>
        <div class="talk-bg">
          {{ $t('borrower2') }}
        </div>
        <div class="child-v-center">
          <img src="@/assets/image/home/borrowers/comments_user02@2x.png">
          <div class="info">
            <div class="name">Hadi Nanda</div>
          </div>
        </div>
      </div>
      <div>
        <div class="talk-bg">
          {{ $t('borrower3') }}
        </div>
        <div class="child-v-center">
          <img src="@/assets/image/home/borrowers/comments_user03@2x.png">
          <div class="info">
            <div class="name">Kirana Nasution</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        borrower1: 'Such a cool website! My loan application has been approved, did not expect that it would be so fast. Furthermore, the process is so easy for people who urgently need money. I really recommend Kredit Pintar. Great website!',
        borrower2: 'Thank God, there is no problem from application to disbursement, for collection the staffs are very professional and the customer service team is very friendly. Thank you Kredit Pintar.',
        borrower3: 'Really helpful for urgent needs, the process is not complicated and very fast. The money is disbursed in the same day that the application is approved. If the chosen product is not approved, Kredit Pintar will offer alternative product which is very helpful, best wishes for Kredit Pintar!',
        meetOurBorrowers: 'Meet Our Borrowers',
      },
      id: {
        borrower1: 'Websitenya keren! Pengajuan saya sudah diterima, tidak disangka akan sangat cepat. Selain itu, prosesnya sangat mudah bagi orang yang membutuhkan uang segera. Kredit Pintar recommended banget deh. Yuk coba juga!',
        borrower2: 'Alhamdulillah, tidak ada masalah dari pengajuan sampai ke pencairan, saat penagihan juga sangat professional dan layanan pelanggannya sangat sopan dan bersahabat. Terima kasih Kredit Pintar.',
        borrower3: 'Sangat membantu apabila ada kebutuhan mendesak, prosesnya tidak rumit dan sangat cepat. Uang cair di hari yang sama dengan pengajuan diterima. Apabila belum disetujui, kredit pintar akan menawarkan pinjaman lain yang sangat membantu, sukses untuk Kredit Pintar!',
        meetOurBorrowers: 'Temui Peminjam Kami',
      },
    },
  },
}
</script>

<style lang="stylus" scoped>
.borrowers {
  margin: 0 auto;
  padding: 95px 0 0;
}

.title {
  font-size: 24px;
  text-align: center;
  padding-bottom: 40px;
}

.items {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0;
  .child-v-center {
    display: flex;
    align-items: center;
  }
}

.items img {
  height: 56px;
}

.talk-bg {
  height: 160px;
  padding: 17px 67px 28px 16px;
  background-image: url('../../assets/image/home/borrowers/comments_dialog@2x.png');
  background-size: 369px;
  margin-bottom: 8px;
  color: #ffffff;
  line-height: 16px;
}

.info {
  display: inline-block;
  margin-left: 8px;
}

.name {
  font-size: 16px;
}
</style>
